<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SellProductFiltersComponent ref="sell-product-search"
                @searchPressed="getProductSeller"
                @changeFieldType="(f) => {fieldType = f}"
                ></SellProductFiltersComponent>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <div v-if="!loading">
                    <ProductSellTable
                        :data="data"
                        :shops="shops"
                        @changeOrderDirection="changeOrderDirection"
                        :order="order"
                        :fieldType="fieldType"
                    ></ProductSellTable>
                </div>
                <div v-else style="text-align: center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep > .v-data-table__wrapper > table {
    border-spacing: 1px;

    th {
        text-align: center !important;
    }
    th,
    td {
        border: 1px solid black;
        font-weight: bold;
    }
}
</style>
<script>
import requests from "../../requests";
import ProductSellTable from "./ProductSellTable.vue";
import SellProductFiltersComponent from "../../components/SellProductFiltersComponent.vue";
export default {
    name: "product-sell",
    components: { ProductSellTable, SellProductFiltersComponent },
    data: () => {
        return {
            loading: false,
            shops: [],
            data: [],
            order: {},
            fieldType: "prezzo"
        };
    },

    mounted() {
        console.log("Product Sell Mounted.");
        let filters = this.$refs['sell-product-search'].getFilters();
        this.fieldType = filters.fieldType;
        this.getProductSeller(filters);
    },
    methods: {
        imagePath(prodId) {
            if (!this.error) {
                let normId = prodId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
        getProductSeller(filters) {
            this.data = [];
            this.loading = true;

            //this.order.direction = null;
            //this.order.field = null;
            requests.getProductSell(filters).then((res) => {
                this.shops = res.data.header;
                this.data = _.orderBy(res.data.data, ["prezzo_tot"], ["desc"]);
                this.loading = false;
            });
        },
        getProdVenditeFromShop(shopId, prod) {
            if (!_.isUndefined(prod.shops[shopId])) {
                return prod.shops[shopId].totale_prezzo;
            } else return 0;
        },

        changeOrderDirection(fieldName) {
            let direction = null;
            if (_.isUndefined(this.order[fieldName])) {
                //this.order[fieldName] = "desc";
                this.order = {};
            } else {
                direction = this.order[fieldName];
            }
            console.log("direction", direction);

            if (direction == null) {
                direction = "desc";
            } else if (direction == "desc") {
                direction = "asc";
            } else direction = null;

            this.order[fieldName] = direction;

            let keys = Object.keys(this.order);

            let directions = [];
            let allNullFlag = true;
            for (let i = 0; i < keys.length; i++) {
                if (this.order[keys[i]] != null) allNullFlag = false;
                directions.push(this.order[keys[i]]);
            }

            if (keys.length == 0 || allNullFlag) {
                this.data = _.orderBy(this.data, ["prezzo_tot"], ["desc"]);
            } else {
                this.data = _.orderBy(this.data, keys, directions);
            }
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
